"use client";
import styled from "@emotion/styled";
import { ButtonStyle } from "@/types/cssTypes";
import { getHoverColor, getPressedColor } from "@/utils/functions";

export const OctagonButton = styled("div")<ButtonStyle>`
  cursor: pointer;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  background: ${({ backgroundColor }) => backgroundColor};
  position: relative;
  justify-content: center;
  align-items: center;
  display: flex;
  border-top: ${({ borderColor }) =>
    borderColor ? `1px solid ${borderColor}` : "none"};
  border-bottom: ${({ borderColor }) =>
    borderColor ? `1px solid ${borderColor}` : "none"};
  margin-left: ${({ borderColor }) => (borderColor ? "-1px" : "0")};
  margin-right: ${({ borderColor }) => (borderColor ? "-1px" : "0")};
`;

export const InlineButtonWithInteractiveStyles = styled("div")<ButtonStyle>`
  position: relative;
  display: flex;
  margin-left: ${({ marginX }) => marginX};
  margin-right: ${({ marginX }) => marginX};
  margin-top: ${({ marginY }) => marginY};

  :hover .styled-custom-button-element {
    fill: ${({ backgroundColor }) => getHoverColor(backgroundColor)} !important;
  }
  :hover div {
    background: ${({ backgroundColor }) =>
      getHoverColor(backgroundColor)} !important;
  }
  :active .styled-custom-button-element {
    fill: ${({ backgroundColor }) =>
      getPressedColor(backgroundColor)} !important;
  }
  :active div {
    background: ${({ backgroundColor }) =>
      getPressedColor(backgroundColor)} !important;
  }
`;

export const HexButtonClass = styled("div")<ButtonStyle>`
  display: inline-block;
  width: ${({ width }) => width};
  color: ${({ backgroundColor }) => backgroundColor};
  cursor: pointer;
  margin-top: ${({ marginY }) => marginY};
  margin-left: ${({ marginX }) => marginX};
  filter: url(#round);
  position: relative;
  :before {
    content: "";
    rotate: 90deg;
    display: block;
    padding-top: 86.6%;
    background: ${({ backgroundColor }) => backgroundColor};
    clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
  }
  :hover:before {
    background: ${({ backgroundColor }) => getHoverColor(backgroundColor)};
  }
  :active:before {
    background: ${({ backgroundColor }) => getPressedColor(backgroundColor)};
  }
`;
